var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-xxl"},[_c('div',[_c('div',{staticStyle:{"padding":"20px 50px 0px 50px"}}),(_vm.typeControlPermission)?_c('Createdtype',{ref:"con1"}):_c('div',[_c('span',{domProps:{"textContent":_vm._s('您沒有該活動類型管理權限')}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }